export default __webpack_public_path__ + "c423ce2dc1d85bc50799720a8129c312.ttf";